/**
 * Employee roles configuration module
 * Defines the available roles in the system with their display properties
 */

const roles = [
  {
    name: "Admin",
    value: "admin",
    color: "purple"
  },
  {
    name: "HR",
    value: "hr",
    color: "info"
  },
  {
    name: "Manager",
    value: "manager",
    color: "success"
  },
  {
    name: "Supervisor",
    value: "supervisor",
    color: "black"
  },
  {
    name: "Employee",
    value: "employee",
    color: "danger"
  }
];

module.exports = { roles };
